// http://maaets.blogspot.com/2012/06/validera-personnummer-med-javascript.html
function validatePersonalNumber(input) {
  // Check valid length & form
  if (!input) return false;

  if (input.indexOf('-') == -1) {
    if (input.length === 10) {
      input = input.slice(0, 6) + '-' + input.slice(6);
    } else {
      input = input.slice(0, 8) + '-' + input.slice(8);
    }
  }
  if (
    !input.match(
      /^(\d{2})(\d{2})(\d{2})\-(\d{4})|(\d{4})(\d{2})(\d{2})\-(\d{4})$/
    )
  )
    return false;

  // Clean input
  input = input.replace('-', '');
  if (input.length == 12) {
    input = input.substring(2);
  }

  // Declare variables
  var d = new Date(
      !!RegExp.$1 ? RegExp.$1 : RegExp.$5,
      (!!RegExp.$2 ? RegExp.$2 : RegExp.$6) - 1,
      !!RegExp.$3 ? RegExp.$3 : RegExp.$7
    ),
    sum = 0,
    numdigits = input.length,
    parity = numdigits % 2,
    i,
    digit;

  // Check valid date
  if (
    Object.prototype.toString.call(d) !== '[object Date]' ||
    isNaN(d.getTime())
  )
    return false;

  // Check luhn algorithm
  for (i = 0; i < numdigits; i = i + 1) {
    digit = parseInt(input.charAt(i));
    if (i % 2 == parity) digit *= 2;
    if (digit > 9) digit -= 9;
    sum += digit;
  }
  return sum % 10 == 0;
}

function validateSsn(value) {
  let valid = true;

  //  Check for correct length, remove characters other than numbers
  const onlyDigits = value.replace(/\D/g, '');
  if (onlyDigits.length !== 10) {
    // && onlyDigits.length !== 12) {
    valid = false;
  }

  //  Check for only numbers & dashes
  if (!/^[-0-9]*$/gm.test(value)) {
    valid = false;
  }

  const passesCheck = validatePersonalNumber(value);

  if (!passesCheck) {
    valid = false;
  }

  return valid;
}

function validateEmail(value) {
  let valid = true;

  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!re.test(value)) {
    valid = false;
  }

  return valid;
}

function validatePostalCode(value) {
  let valid = true;

  const re = /[0-9]/g;

  if (!re.test(value) || value.length !== 5) {
    valid = false;
  }

  return valid;
}

function validateNumber(value) {
  return /^\d+$/.test(value);
}

function validateLandlordPhone(value, currentApplicant) {
  let valid = true;

  if (!/^\d+$/.test(value)) {
    valid = false;
  }

  const { member1, member2 } = currentApplicant.members;

  const member1Phone = member1.phone;
  const member2Phone = member2 && member2.phone;

  if (value === member1Phone || value === member2Phone) {
    valid = false;
  }

  return valid;
}

function validateLandlordEmail(value, currentApplicant) {
  let valid = true;

  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!re.test(value)) {
    valid = false;
  }

  const { member1, member2 } = currentApplicant.members;

  const member1Email = member1.email;
  const member2Email = member2 && member2.email;

  if (value === member1Email || value === member2Email) {
    valid = false;
  }

  return valid;
}

function validateLandlordName(value) {
  const forbiddenNames = ['sweden', 'sverige', 'privat', 'private'];

  if (forbiddenNames.includes(value.toLowerCase())) {
    return false;
  }

  return true;
}

export {
  validateSsn,
  validateEmail,
  validatePostalCode,
  validateNumber,
  validateLandlordEmail,
  validateLandlordPhone,
  validateLandlordName,
};



// WEBPACK FOOTER //
// ./src/components/InputField/validations.js